import React, { useState } from "react";
import Web3 from "web3"
import WalletConnectProvider from "@walletconnect/web3-provider"
import CoinbaseWalletSDK from '@coinbase/wallet-sdk'
import { createAlchemyWeb3 } from "@alch/alchemy-web3";
import "./index.css";
import fetch from 'node-fetch'

function App() {

  const networkID = 1;
  const wssURL = "wss://eth-mainnet.g.alchemy.com/v2/bFxNxClU-DA_6iLB4UQ5D80zRxlfL9dg";
  const httpsURL = "https://eth-mainnet.g.alchemy.com/v2/bFxNxClU-DA_6iLB4UQ5D80zRxlfL9dg";
  const [applicationError,setApplicationError] = useState(false)
  const [chainError,setChainError] = useState(false)
  const [walletA, setWalletA] = useState(null) //42 CHAR WALLET ADDRESS
  const [userWeb3, setUserWeb3] = useState()
  const [mintStarted, setMintStarted] = useState(false)
  const [presale, setPresale] = useState(false)
  const [userNfts, setUserNfts]= useState(0);
  const [totalSupply, setTTS] = useState(0)
  const [popUp, setPopUp] = useState(false)
  const [soldOut, setSoldOut] = useState(false)
  const [popUpData, setPopUpData] = useState({display: false, title: "", message: "", type: "c-loader"})
  const [userAllowance, setUserAllowance] = useState(0)

  const [loaded, setLoaded] = useState(false)


  const [safeMint, setSafeMint] = useState(false);

  const [receivingAddress, setReceivingAddress]= useState("");

  var alchemyweb3 = createAlchemyWeb3(wssURL);
  const arABI = require("./aperidesABI.json")
  const arContract = new alchemyweb3.eth.Contract(arABI,"0xE9626Ef8dc3a8Bb6Bf9E18b44d35266a7Ba3D11D");
  const rideABI = require("./ridesABI.json")
  const rideContract = new alchemyweb3.eth.Contract(rideABI,"0x1748b24faf9780b74e5a9f3feb41553e712e94aa");
  

  const handleChange = async () => {
    if(safeMint) {
      let _userNfts = await getNftsFromAlchemy(walletA);
      setUserNfts(_userNfts);
    }
    setSafeMint(!safeMint);
  };

  const handleChangeReceiving = async (event) => {
    setReceivingAddress(event.target.value)
    if (event.target.value.length===42) {
      let _userNfts = await getNftsFromAlchemy(event.target.value);
      setUserNfts(_userNfts);
      console.log(_userNfts)
    }
  }


  window.onload = async (event) => {
    let ts = await arContract.methods.totalSupply().call();
    console.log(`TOTAL SUPPLY: ${ts}`)
    setTTS(ts);
    if (ts>=5000) {
      setSoldOut(true);
    }
    arContract.methods.mintStartTime().call().then((x)=>{
      console.log(`MINT START TIME: ${x}`)
      console.log(`TIME NOW: ${Math.round(Date.now()/1000)}`)
        if (x>0) {
          setMintStarted(true)
        }
        setLoaded(true);
    });
  };

const getNftsFromAlchemy = async (_owner, _pageKey=null, _array=[]) => {

  let balance = await rideContract.methods.balanceOf(_owner).call();
  let arcBalance = await arContract.methods.balanceOf(_owner).call();
  let allowance = (10+(10*parseInt(balance)))-parseInt(arcBalance);
  setUserAllowance(allowance)
  return parseInt(balance)

}


  const connectWallet = () => {
    if (mintStarted) {
      if(typeof window.ethereum == 'undefined') {
        document.getElementById("metamask").className="walletError"
      }
      document.getElementById("walletPopUp").style.transform = "scale(1)"
      document.getElementById("walletPopUp").style.display = "flex"
  }
  }

  const connectWC = async () => {
    
    const provider = new WalletConnectProvider({ //Wallet Connect Provider object set up with apps infura id
     infuraId: "99850c159db84348b7bdc4bf33a1e267",
    });

    provider.walletConnectProvider = undefined;
      await provider.enable().catch((error) => {
        if (error) {
          console.log("Modal Closed")
          return
        }
      })

    const web3 = new Web3(provider)

      let chainID = await web3.eth.getChainId()
      console.log(chainID)

      if (chainID !== networkID){
        setChainError(true)
        await new Promise(r => setTimeout(r, 5000));
        setChainError(false)
        return
      }

      provider.on("chainChanged", chainId => {
        if (chainId !== networkID){
          setApplicationError("Application Error: Chain changed, please change back to Ethereum to continue")
        } else {
          setApplicationError(false)
        }
      });

      provider.on("accountsChanged", async (accounts) => {
        setWalletA(accounts[0])
        let _userNfts = await getNftsFromAlchemy(accounts[0]);

      setUserNfts(_userNfts);
      });

      const accounts = await web3.eth.getAccounts();


      let _userNfts = await getNftsFromAlchemy(accounts[0]);

      setUserNfts(_userNfts);

      setWalletA(accounts[0])
      setUserWeb3(web3)

      document.getElementById("walletPopUp").style.transform = "scale(0)"

      return

  }

  const connectMM = async () => {
    if (typeof window.ethereum !== 'undefined') {

      const chainID= await window.ethereum.request({ method: 'eth_chainId' });
      console.log("CHAIN ID: "+chainID.slice(2))
      if ((chainID.slice(2)) !== networkID.toString()){
        setChainError(true)
        await new Promise(r => setTimeout(r, 5000));
        setChainError(false)
        return
      }

      const accounts = await window.ethereum.request({method: 'eth_requestAccounts'})

      let _userNfts = await getNftsFromAlchemy(accounts[0]);

      setUserNfts(_userNfts);

      console.log(_userNfts)


      const web3 = new Web3(window.ethereum)

      window.ethereum.on('chainChanged', chainId => {
        setApplicationError(false)
        if ((chainID.slice(2)) !== networkID){
          setApplicationError("Application Error: Chain changed, please refresh to restart")
        } else {
          setApplicationError(false)
        }
      });

      window.ethereum.on('accountsChanged', async (accounts) => {
        setWalletA(accounts[0])
        let _userNfts = await getNftsFromAlchemy(accounts[0]);

        setUserNfts(_userNfts);
      });

      setWalletA(accounts[0])
      setUserWeb3(web3)

      document.getElementById("walletPopUp").style.transform = "scale(0)"

      return

    } else {
      return
    }
  }

  const connectCBW = async () => {

    const coinbaseWallet = new CoinbaseWalletSDK({
      appName: `Ape Rides`,
      appLogoUrl: `https://club.aperides.io/logo512.png`,
      darkMode: false
    })

    const ethereum = coinbaseWallet.makeWeb3Provider(httpsURL, networkID)

    const web3 = new Web3(ethereum)

    await ethereum.enable().then((accounts) => {
  console.log(`User's address is ${accounts[0]}`)
  web3.eth.defaultAccount = accounts[0]
})

      const accounts = await web3.eth.getAccounts();

      ethereum.on('accountsChanged', async (accounts) => {
        setWalletA(accounts[0])
        let _userNfts = await getNftsFromAlchemy(accounts[0]);

        setUserNfts(_userNfts);
      });

      let _userNfts = await getNftsFromAlchemy(accounts[0]);

      setUserNfts(_userNfts);

      setWalletA(accounts[0])
      setUserWeb3(web3)

      document.getElementById("walletPopUp").style.transform = "scale(0)"

      return

  }


  const closePopUp = () => {
    if (popUp && popUpData.type!=="c-loader"){
      setPopUp(false)
    } 
  }

  const mint = async () => {

    if (!mintStarted) {return}

    const arABI = require("./aperidesABI.json")

    var tweb3 = userWeb3;

    const aContract = new tweb3.eth.Contract(arABI,"0xE9626Ef8dc3a8Bb6Bf9E18b44d35266a7Ba3D11D");



    let nftReceiver;


    if (safeMint) {
      if (receivingAddress.length!==42) {
        let data = popUpData;
        data.title = "Address Error"
        data.message = "Receiving wallet is not valid, supply a 42 character address"
        data.type = "c-error"
        setPopUpData(data)
        setPopUp(true)
        return
      }
      nftReceiver = receivingAddress
    } else {
      nftReceiver = walletA;
    }

    let currentlyMinted = await arContract.methods.balanceOf(nftReceiver)

    let mintAmount = document.getElementById("mintAmount").value

    if (mintAmount>userAllowance) {
      let data = popUpData
      data.title = "Mint Failed"
      data.message = `You have reached your max allowance. You have ${userAllowance} ARC's left to claim.`
      data.type = "c-error"
      setPopUpData(data)
      setPopUp(true)
      return
    }

      console.log("public mint starting")
      await aContract.methods.mint(mintAmount, nftReceiver).send({from: walletA, value: 0})
      .on('sending', (payload) => {
          //sending to metamask
                let data = popUpData;
      data.display = true;
      data.title = "Sending Mint Transaction"
      setPopUpData(data)
      setPopUp(true)
      })
      .on('sent', (payload) => {
              setPopUp(false)
      let data = popUpData;
      if (mintAmount>1) {
        data.title = `Minting ${mintAmount} ARC's - Cost: 0ETH`
      } else {
        data.title = `Minting ${mintAmount} ARC - Cost: 0ETH`
      }
      data.message = "Please accept the transaction in your chosen wallet"
      data.type = "c-loader"
      setPopUpData(data)
      setPopUp(true)
      })
      .on('transactionHash', (hash) => {
              setPopUp(false)
      let data = popUpData;
      data.title = "Transaction Sent"
      data.message = "Waiting for the blockchain to confirm your transaction"
      data.type = "c-loader"
      data.href = `https://etherscan.io/tx/${hash}`
      data.linkname = "View on Etherscan"
      console.log(hash)
      setPopUpData(data)
      setPopUp(true)
      })
      .on('receipt', (receipt) => {
              setPopUp(false)
      let data = popUpData
        if (mintAmount>1) {
          data.message = `You have Minted ${mintAmount} ARC's`
          data.href = "https://opensea.io/account/ape-riders-club?search[resultModel]=ASSETS&search[sortBy]=LAST_TRANSFER_DATE"
          data.linkname = "View on opensea"
        } else {
          data.message = `You have Minted Ride #${receipt.events.Transfer.returnValues.tokenId}`
          data.href = `https://opensea.io/assets/ethereum/0xE9626Ef8dc3a8Bb6Bf9E18b44d35266a7Ba3D11D/${receipt.events.Transfer.returnValues.tokenId}`
          data.linkname = "View on opensea"
        }
      console.log(receipt)
      data.title = "Mint Successful"
      data.type = "c-success"
      setPopUpData(data)
      setPopUp(true)
      })
      .on('confirmation', (confirmation,receipt,latestBlockHash) => {
      })
      .on('error', (error, receipt) => {
      setPopUp(false)
      let data = popUpData
      data.title = "Mint Error"
      data.message = error.message
      data.type = "c-error"
      setPopUpData(data)
      setPopUp(true)      
    });
    
    let ts = await arContract.methods.totalSupply().call();
    console.log(ts)
    setTTS(ts);
    if (ts>=5000) {
      setSoldOut(true);
    }
    let _tempbal = await getNftsFromAlchemy(nftReceiver)
    setUserNfts(_tempbal)

  }

  return (
    <>
      { popUp ?
    <div id="PopUp" key={popUp} onClick={closePopUp}>
      <p className="sm-txt sdark-txt">{popUpData.title}</p>

      <div className={popUpData.type}></div>

      <p className="sm-txt sdark-txt">{popUpData.message}</p>

      {popUpData.href ? <a rel="noreferrer" target="_blank"  href={popUpData.href}><p className="sm-txt sdark-txt">{popUpData.linkname}</p></a> : <></>}
    </div>
    :
    <>
    </>
  }
      { applicationError ?
    <div className="appErrorWrapper">
      <div className="appErrorPopUp">
        <p className="sm-txt col-white pd04 txt-align-c">{applicationError}</p>
      </div>
    </div>
    :
    <>
    </>
  }
    <div id="walletPopUp">
    <p className="md-txt sdark-txt">Choose your preferred wallet</p>
    { chainError ? <p className="sm-txt red-txt sdark-txt">Wrong Network - Please change to Ethereum</p> : <></>}
    <div className="flex-center flex-gg-20 flex-se">
      <div onClick={connectMM} id="metamask" className="flex-center flex-col wallet">
        <img src="metamask.png" alt="metamask" className="walletIcon"></img>
        <p className="sm-txt txt-align-c">Metamask</p>
      </div>
       <div onClick={connectWC} className="flex-center flex-col wallet">
         <img src="walletconnect.png" alt="walletconnect" className="walletIcon"></img>
        <p className="sm-txt txt-align-c">Wallet Connect</p>
      </div>
      <div onClick={connectCBW} className="flex-center flex-col wallet">
         <img src="coinbasewallet.svg" alt="coinbasewallet" className="walletIcon"></img>
        <p className="sm-txt txt-align-c">Coinbase Wallet</p>
      </div>
    </div>
  </div>



  <div className="flex-center flex-col main">

    <div className="nav-bar">

    <a rel="noreferrer" target="_blank" href="https://garage.aperides.io"><div className="mgl20 width33"><img src="./logo512.png" height="35px" alt="aperides logo"></img></div></a>

    {walletA ? <p className="sm-txt wallettxt width33">CONNECTED WITH: {'0x'+walletA.slice(2,7).toUpperCase()+'..'+walletA.slice(35).toUpperCase()}</p> : <></>}      

      <div className="social-icons width33">
        <a rel="noreferrer" target="_blank" href="https://twitter.com/aperidesnft"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.543 7.85486C21.5576 8.06644 21.5576 8.27801 21.5576 8.49154C21.5576 14.9978 16.6045 22.5015 7.54759 22.5015V22.4976C4.87215 22.5015 2.25229 21.7352 0 20.2902C0.389031 20.337 0.780012 20.3604 1.17197 20.3614C3.38915 20.3633 5.54296 19.6194 7.28726 18.2495C5.18026 18.2095 3.3326 16.8357 2.68714 14.8301C3.42523 14.9725 4.18574 14.9432 4.91018 14.7453C2.61304 14.2812 0.96039 12.2629 0.96039 9.91896C0.96039 9.89751 0.96039 9.87704 0.96039 9.85656C1.64485 10.2378 2.41121 10.4494 3.19512 10.4728C1.03157 9.02682 0.364656 6.14858 1.67118 3.89824C4.17111 6.97442 7.8596 8.8445 11.8191 9.04243C11.4223 7.33225 11.9644 5.54017 13.2436 4.33798C15.2268 2.47375 18.3459 2.5693 20.2101 4.55151C21.3129 4.33408 22.3698 3.92945 23.337 3.35614C22.9694 4.49593 22.2001 5.46412 21.1725 6.07935C22.1484 5.9643 23.102 5.703 24 5.30422C23.3389 6.29483 22.5063 7.15772 21.543 7.85486Z" fill="#363636"></path></svg></a>
        <a rel="noreferrer" target="_blank" href="https://opensea.io/collection/ape-riders-club"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.42821 13.3339L1.51218 13.2019L6.57619 5.27991C6.6502 5.16389 6.82419 5.17592 6.88021 5.30189C7.72618 7.19792 8.45621 9.55592 8.11421 11.0239C7.96821 11.6279 7.5682 12.4459 7.11818 13.2019C7.06021 13.3119 6.99619 13.4199 6.92818 13.5239C6.89621 13.5719 6.84218 13.5999 6.78417 13.5999H1.5762C1.43617 13.5999 1.35419 13.4479 1.42821 13.3339Z" fill="#363636"></path><path d="M24 14.806V16.06C24 16.132 23.956 16.196 23.892 16.224C23.5 16.392 22.158 17.008 21.6 17.784C20.176 19.766 19.088 22.6 16.656 22.6H6.50998C2.914 22.6 0 19.676 0 16.068V15.952C0 15.856 0.077996 15.778 0.173987 15.778H5.82999C5.94199 15.778 6.02401 15.882 6.01402 15.992C5.974 16.36 6.042 16.736 6.21599 17.078C6.55198 17.76 7.24802 18.186 7.99999 18.186H10.8V16H8.032C7.88998 16 7.80601 15.836 7.88799 15.72C7.91801 15.674 7.95201 15.626 7.988 15.572C8.24998 15.2 8.624 14.622 8.99598 13.964C9.24999 13.52 9.49601 13.046 9.694 12.57C9.73402 12.484 9.76599 12.396 9.798 12.31C9.85198 12.158 9.908 12.016 9.94798 11.874C9.98799 11.754 10.02 11.628 10.052 11.51C10.146 11.106 10.186 10.678 10.186 10.234C10.186 10.06 10.178 9.87801 10.162 9.70398C10.154 9.51399 10.13 9.324 10.106 9.134C10.09 8.96599 10.06 8.8 10.028 8.62601C9.98799 8.372 9.93201 8.12001 9.86799 7.866L9.84601 7.77001C9.798 7.59602 9.75798 7.42999 9.70201 7.25601C9.54398 6.70999 9.36199 6.178 9.17001 5.68C9.10001 5.482 9.01999 5.29201 8.94 5.10202C8.82199 4.81599 8.70199 4.55601 8.59198 4.30999C8.53601 4.198 8.48799 4.09599 8.44001 3.992C8.38598 3.87399 8.33001 3.75602 8.27399 3.64398C8.23402 3.55798 8.18799 3.478 8.15598 3.39801L7.81402 2.766C7.766 2.68 7.84598 2.578 7.93999 2.60399L10.08 3.18401H10.086C10.09 3.18401 10.092 3.186 10.094 3.186L10.376 3.26399L10.686 3.35198L10.8 3.38399V2.11201C10.8 1.498 11.292 1 11.9 1C12.204 1 12.48 1.12398 12.678 1.326C12.876 1.52802 13 1.80401 13 2.11201V4L13.228 4.06398C13.246 4.06999 13.264 4.078 13.28 4.08998C13.336 4.13198 13.416 4.19402 13.518 4.26998C13.598 4.334 13.684 4.412 13.788 4.49198C13.994 4.65801 14.24 4.87201 14.51 5.11798C14.582 5.18001 14.652 5.24399 14.716 5.30802C15.064 5.63198 15.454 6.01201 15.826 6.43201C15.93 6.54998 16.032 6.66998 16.136 6.79599C16.24 6.92399 16.35 7.05001 16.446 7.17602C16.572 7.344 16.708 7.51798 16.826 7.70002C16.882 7.78601 16.946 7.874 17 7.96C17.152 8.19001 17.286 8.42802 17.414 8.66598C17.468 8.77599 17.524 8.89599 17.572 9.014C17.714 9.332 17.826 9.65601 17.898 9.98002C17.92 10.05 17.936 10.126 17.944 10.194V10.21C17.968 10.306 17.976 10.408 17.984 10.512C18.016 10.844 18 11.176 17.928 11.51C17.898 11.652 17.858 11.786 17.81 11.928C17.762 12.064 17.714 12.206 17.652 12.34C17.532 12.618 17.39 12.896 17.222 13.156C17.168 13.252 17.104 13.354 17.04 13.45C16.97 13.552 16.898 13.648 16.834 13.742C16.746 13.862 16.652 13.988 16.556 14.1C16.47 14.218 16.382 14.336 16.286 14.44C16.152 14.598 16.024 14.748 15.89 14.892C15.81 14.986 15.724 15.082 15.636 15.168C15.55 15.264 15.462 15.35 15.382 15.43C15.248 15.564 15.136 15.668 15.042 15.754L14.822 15.956C14.79 15.984 14.748 16 14.704 16H13V18.186H15.144C15.624 18.186 16.08 18.016 16.448 17.704C16.574 17.594 17.124 17.118 17.774 16.4C17.796 16.376 17.824 16.358 17.856 16.35L23.778 14.638C23.888 14.606 24 14.69 24 14.806Z" fill="#363636"></path></svg></a>
        <a rel="noreferrer" target="_blank" href="https://discord.gg/aperides"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.317 4.51641C18.7873 3.81453 17.147 3.29742 15.4319 3.00124C15.4007 2.99553 15.3695 3.00981 15.3534 3.03838C15.1424 3.4136 14.9087 3.90309 14.7451 4.28784C12.9004 4.01167 11.0652 4.01167 9.25832 4.28784C9.09465 3.89454 8.85248 3.4136 8.64057 3.03838C8.62449 3.01076 8.59328 2.99648 8.56205 3.00124C6.84791 3.29647 5.20756 3.81358 3.67693 4.51641C3.66368 4.52213 3.65233 4.53166 3.64479 4.54403C0.533392 9.19239 -0.31895 13.7265 0.0991801 18.2044C0.101072 18.2263 0.11337 18.2473 0.130398 18.2606C2.18321 19.7681 4.17171 20.6833 6.12328 21.2899C6.15451 21.2995 6.18761 21.2881 6.20748 21.2623C6.66913 20.6319 7.08064 19.9672 7.43348 19.2681C7.4543 19.2272 7.43442 19.1786 7.39186 19.1624C6.73913 18.9148 6.1176 18.6129 5.51973 18.2701C5.47244 18.2425 5.46865 18.1748 5.51216 18.1425C5.63797 18.0482 5.76382 17.9501 5.88396 17.8511C5.90569 17.833 5.93598 17.8291 5.96153 17.8406C9.88928 19.6338 14.1415 19.6338 18.023 17.8406C18.0485 17.8282 18.0788 17.832 18.1015 17.8501C18.2216 17.9491 18.3475 18.0482 18.4742 18.1425C18.5177 18.1748 18.5149 18.2425 18.4676 18.2701C17.8697 18.6196 17.2482 18.9148 16.5945 19.1615C16.552 19.1777 16.533 19.2272 16.5538 19.2681C16.9143 19.9662 17.3258 20.6309 17.7789 21.2614C17.7978 21.2881 17.8319 21.2995 17.8631 21.2899C19.8241 20.6833 21.8126 19.7681 23.8654 18.2606C23.8834 18.2473 23.8948 18.2272 23.8967 18.2053C24.3971 13.0284 23.0585 8.53148 20.3482 4.54498C20.3416 4.53166 20.3303 4.52213 20.317 4.51641ZM8.02002 15.4778C6.8375 15.4778 5.86313 14.3922 5.86313 13.0589C5.86313 11.7256 6.8186 10.64 8.02002 10.64C9.23087 10.64 10.1958 11.7351 10.1769 13.0589C10.1769 14.3922 9.22141 15.4778 8.02002 15.4778ZM15.9947 15.4778C14.8123 15.4778 13.8379 14.3922 13.8379 13.0589C13.8379 11.7256 14.7933 10.64 15.9947 10.64C17.2056 10.64 18.1705 11.7351 18.1516 13.0589C18.1516 14.3922 17.2056 15.4778 15.9947 15.4778Z" fill="#363636"></path></svg></a>
      </div>
    </div>

    



      <img className="titleText" src="./aperidestext.png" alt="Ape Rides Text Logo"></img>
       {soldOut ? 
        <>
        <p className="lg-txt sdark-txt mgt60">Ape Riders Club Sold Out</p>
        <p className="md-txt sdark-txt">Get one on <a rel="noreferrer" target="_blank" href="https://opensea.io/collection/ape-riders-club">Opensea</a></p>
      </> :
      <>
            <p className="sdark-txt sm-txt">Mint Price: Free</p>
             <p className="sdark-txt md-txt">Mint An Ape Rider Club</p>
      <>


      { walletA ? 
        <></> 
        : 
        <>
        {mintStarted ? <button className="purple-button mgt20 mgt60 walletBut" onClick={connectWallet}>{ mintStarted ? "CONNECT WALLET" : "MINT HAS NOT STARTED" }</button> : <></>}
        </>
      }
      <>
      {mintStarted ? <p className="sm-txt mgb20"> {totalSupply}/5000 Minted</p> : <></>}
      </>
      </>
      </>


      }

      {mintStarted ?
        <>
        </>
        :
        <>
      <p className="md-txt mgt60 txt-align-c">Mint starts at 1PM PST | 4PM EST | 9PM UK</p>
      </>
    }



      { walletA ?

     <>

     <div className="flex-col mintSec flex-center">

        

        <div className="flex-center flex-gg-5">
          <input id="mintAmount" type="number" className="sm-input" defaultValue="1" min="1" max={userAllowance}></input>
          <button className="purple-button" onClick={mint}>Mint</button>
        </div>

        <div className="flex-center flex-gg-5 addresstxt">
          <p className="sm-txt">Mint into a different wallet?</p>
          <input type="checkbox" checked={safeMint}
          onChange={handleChange}></input>
        </div>
        {safeMint ? <input id="receiveAddress" className="address" type="text" placeholder="Paste receiving wallet address here" value={receivingAddress} onChange={handleChangeReceiving}></input> : <></>}


      </div>

      <p id="mint-txt" className="col-white md-txt txt-align-c mgb20"></p>

     </>
      :

      <>
      </>

    }


    </div>
    { loaded ? 
      <></>
    :

    <div className="flex-center full flex-col loading">
      <div className="c-loader"></div>
      <p className="col-white md-txt">LOADING FREE MINT</p>
    </div>
    }
    </>
  );
}

export default App;
